export default function QMS() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-62ac14c elementor-section-full_width elementor-section-height-default elementor-section-height-default"
      data-id="62ac14c"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2db0e3e"
          data-id="2db0e3e"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-ea15619 elementor-widget elementor-widget-heading"
              data-id="ea15619"
              data-element_type="widget"
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h3 className="elementor-heading-title elementor-size-default">
                  Documentation
                </h3>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-b02eb3c elementor-widget elementor-widget-text-editor"
              data-id="b02eb3c"
              data-element_type="widget"
              data-widget_type="text-editor.default"
            >
              <div className="elementor-widget-container">
                We ensure that your company can build and deliver quality
                products that’ll ultimately lead to an increase in revenue and
                boost your business
              </div>
            </div>
          </div>
        </div>
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4734801"
          data-id="4734801"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-0c4f93c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="0c4f93c"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f412505"
                  data-id="f412505"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-70a1f8b elementor-widget elementor-widget-heading"
                      data-id="70a1f8b"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          ISO 9001
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-4444398 elementor-widget elementor-widget-text-editor"
                      data-id="4444398"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Aims to help any organization, no matter the share or
                          size, improve customer satisfaction and demonstrate
                          consistency when it comes to the products and services
                          provided
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b3960f0"
                  data-id="b3960f0"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-5859ccb elementor-widget elementor-widget-heading"
                      data-id="5859ccb"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          IT Service Management (ISO 20000)
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-a81ffc8 elementor-widget elementor-widget-text-editor"
                      data-id="a81ffc8"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Allows organizations to determine how efficiently
                          they’re carrying out managed services, estimate
                          service levels, and analyze their performance
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-4ef557e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="4ef557e"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d33776c"
                  data-id="d33776c"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-7919bba elementor-widget elementor-widget-heading"
                      data-id="7919bba"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Aerospace Management Systems (AS9100)
                        </h4>
                      </div>
                    </div>

                    <div
                      className="elementor-element elementor-element-a980020 elementor-widget elementor-widget-text-editor"
                      data-id="a980020"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Enables organizations in the aviation industry to
                          develop, or offer aviation, defense, and space
                          products and services
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
}
